<template>
  <div class="editemail">
    <div class="title">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="to">
        <el-breadcrumb-item :to="{ path: '/account/settings' }">{{$vi18n('$i18n# 账户设置 #i18n$')}}</el-breadcrumb-item>
        <el-breadcrumb-item class="to_back">{{$vi18n('$i18n# 修改 #i18n$')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content" v-if="!success">
      <step :activity="step" class="step"></step>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item prop="phone">
          <el-input v-if="step == 1" :value="form.email" :disabled="true">
            <template slot="prepend">{{ title }}</template>
          </el-input>
          <el-input v-else v-model="form.email" :disabled="step == 1">
            <template slot="prepend">{{ title }}</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="form.code">
            <template slot="append">
              <el-button @click="getCode">{{ timer }}</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="loading"
            type="primary"
            style="width: 360px"
            @click="submitForm('form')"
            >{{$vi18n('$i18n# 下一步 #i18n$')}}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="succse" v-if="success">
      <div class="icon"></div>
      <div class="word">{{$vi18n('$i18n# 修改成功 #i18n$')}}</div>
      <el-button type="primary" @click="back">{{$vi18n('$i18n# 返回 #i18n$')}}</el-button>
    </div>
  </div>
</template>

<script lang="js">
import step from '@/components/step.vue';
import { mapState } from 'vuex';
import { getCode, bindNewEmail, checkCode } from '@/api/account.js';
import { getKfzInfo } from '@/api/common';
import store from '@/store/index.js';
export default {
  components: {
    step
  },
  data() {
    return {
      success: false,
      step: 1,
      form: {
        email: '',
        code: ''
      },
      rules: {},
      Time: '',
      lock: true,
      timer: null,
      title: '',
      loading: false
    };
  },
  computed: {
     ...mapState(['developerInfo']),
  },
  methods: {
    initData() {
      this.rules = {
        code: [
          {
            required: true,
            message: this.$vi18n('$i18n# 请输入你收到的验证码 #i18n$'),
            trigger: 'blur',
          }
        ]
      };
      this.title = this.$vi18n('$i18n# 原邮箱 #i18n$');
      this.timer = this.$vi18n('$i18n# 获取验证码 #i18n$');
      this.form.email = this.developerInfo.email;
    },
    back() {
      this.$router.replace('/account/settings');
    },
    async getCode() {
      if (this.lock) {
        try {
          const res = await getCode({
            uin: sessionStorage.getItem('uin'),
            email: this.form.email,
          });

          this.$message({
            message: this.$vi18n('$i18n# 验证码已发送至您的邮箱! #i18n$'),
            type: 'success',
          });
          this.lock = false;
          let time = 60;
          this.timer = time + 's';
          this.Time = setInterval(() => {
            if (time === 0) {
              this.timer = this.$vi18n('$i18n# 获取验证码 #i18n$');
              clearInterval(this.Time);
              this.lock = true;
            } else {
              time = time - 1;
              this.timer = time + 's';
            }
          }, 1000);
        } catch (error) {
          console.log(error);
        }
      } else {
        this.$message({
          message: this.$vi18n('$i18n# 你的操作太频繁! #i18n$'),
          type: 'warning',
        });
      }
    },
    async bindNew() {
      try {
        const res = await bindNewEmail({
          uin: sessionStorage.getItem('uin'),
          email: this.form.email
        });
        this.success = true;
        this.refreshAccount()
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async refreshAccount() {
      store.dispatch('refreshDeveloperInfo')
    },
    async submitForm(form) {
      const ref = this.$refs[form];
      ref.validate(async (valid) => {
        if (this.step === 2) {
          try {
            this.loading = true;
            const res = await checkCode({
              uin: sessionStorage.getItem('uin'),
              sms_code: this.form.code,
              sub_req: 'change_email',
            });
            this.bindNew();
          } catch (error) {
            console.log(error);
          } finally {
            this.loading = false;
          }
        }
        if (valid) {
          if (this.step === 1) {
            try {
              this.loading = true;
              const data = await checkCode({
                uin: sessionStorage.getItem('uin'),
                sms_code: this.form.code,
                sub_req: 'change_email',
              });
              this.step = 2;
              this.form.code = '';
              this.form.email = '';
              this.title = this.$vi18n('$i18n# 新邮箱 #i18n$');
              clearInterval(this.Time);
              this.timer = this.$vi18n('$i18n# 获取验证码 #i18n$');
              this.lock = true;
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          }
        }
      });
    }
  },
  created() {
    this.initData();
    this.refreshAccount()
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin: auto;
  font-size: 24px;
  font-weight: 400;
  line-height: 69px;
  color: rgba(89, 89, 89, 1);
  width: 976px;
  height: 60px;
  border-bottom: 1px solid rgba(217, 217, 217, 1);

  .to {
    font-size: 20px;
    line-height: 69px;
    margin-left: 10px;
  }
}

.succse {
  .icon {
    width: 100px;
    height: 100px;
    background: url("../../../assets/images/ico_succeed.svg") no-repeat;
    background-size: 100px 100px;
    margin: auto;
    margin-top: 100px;
  }

  .word {
    font-size: 24px;
    color: rgba(89, 89, 89, 1);
    text-align: center;
    margin-top: 20px;
  }

  .el-button {
    margin-top: 100px;
    position: relative;
    width: 200px;
    height: 50px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
  }
}

.content {
  margin-top: 100px;

  .el-form {
    width: 360px;
    margin: auto;
    margin-top: 55px;
  }

  .step {
    display: flex;
    justify-content: center;
  }
}
</style>
